import React from 'react';
import { View } from 'react-native';
import { rem } from 'design-system';
import Button from 'design-system/Button';
import Text from 'design-system/Text';
import useStyles from 'hooks/useStyles';
import { useAppSelector } from 'store/hooks';
import createStyleSheets from 'utils/createStyleSheets';
import useConnectToSuggestedBank from '../hooks/useConnectToSuggestedBank';
import { selectConnectionSuggestionForReportAccount, selectShouldShowSuggestedConnections, } from '../selectors';
const strings = {
    title: 'Track this account',
    description: (bankName) => bankName
        ? `Connect your ${bankName} account to see live balances and track your spending in Emma`
        : 'Connect your account to see live balances and track your spending in Emma',
    cta: 'Connect',
};
const ConnectSuggestedBankCard = ({ tuAccountId, routeKey, }) => {
    const styles = useStyles(styleSet);
    const shouldShow = useAppSelector(selectShouldShowSuggestedConnections);
    const suggestion = useAppSelector((state) => selectConnectionSuggestionForReportAccount(state, tuAccountId));
    const onConnect = useConnectToSuggestedBank(shouldShow ? suggestion : undefined, routeKey);
    const isVisible = shouldShow && !!suggestion && !!onConnect;
    if (!isVisible)
        return null;
    return (<View style={styles.container}>
      <Text Text-16>{strings.title}</Text>
      <Text TextThin-14 Secondary style={styles.description}>
        {strings.description(suggestion.bankName)}
      </Text>
      <View style={styles.buttonRow}>
        <Button brandLight square hug title={strings.cta} onPress={onConnect} style={styles.buttonPadding}/>
      </View>
    </View>);
};
const styleSet = createStyleSheets((colors) => ({
    container: {
        marginHorizontal: rem(16),
        marginTop: rem(16),
        padding: rem(16),
        borderRadius: rem(16),
        backgroundColor: colors.cards.onDark,
    },
    description: {
        marginTop: rem(4),
        marginBottom: rem(12),
    },
    buttonRow: {
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center',
    },
    buttonPadding: {
        paddingHorizontal: rem(8),
    },
}));
export default React.memo(ConnectSuggestedBankCard);
